import Navbar from "./Navbar";
import Footer from "./Footer";

// Shared shell for legal / informational pages (privacy, terms, sitemap, contact).
export function PageShell({ eyebrow, title, children, wide = false }) {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className={`mx-auto px-4 sm:px-6 lg:px-8 py-14 ${wide ? "max-w-6xl" : "max-w-3xl"}`}>
        {eyebrow && (
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#BA7517]">{eyebrow}</div>
        )}
        <h1 className="mt-3 font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#1a1a18]">{title}</h1>
        {children}
      </div>
      <Footer />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-heading text-lg font-semibold text-[#1a1a18]">{heading}</h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-neutral-600">{children}</div>
    </section>
  );
}
